module.exports = __webpack_public_path__ + "static/img/spirit-world-ink-map.113b3c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spirit-world-ink-map.jpg
// module id = lo+U
// module chunks = 4